import React from 'react';
import "./notFound.scss"

const NotFound = () => {
    return (
        <div className="not_found">
            {/* <h1>404!</h1>
            <h3>Page Not Found</h3> */}
            <h1>Under Construction..!!!</h1>
            <h3>We will be coming Soon...... </h3>
        </div>
    );
};

export default NotFound;